import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'ci.prediction_models'

const state = {
  ...makeTableCommonState()
}

const getters = {
  pageTitle: () => 'Currently used prediction models',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: 1,
      update: -1,
      delete: -1,
      downloadList: -1,
      uploadList: -1
    }
  },

  columns: () => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left' },
      { name: 'objective', label: 'Objective', field: 'objective', uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'source_of_res_param', label: 'Source of reservation option', field: 'source_of_res_param', uiFilterTypes: ['selectedValuesFilter'], labelColorMap: { all: 'var(--theme-30)', organic: 'var(--theme-blue-30)', broker: 'var(--theme-red-30)' }, align: 'left' },
      { name: 'hours_before_class_start_param', label: 'Hours before class start', field: 'hours_before_class_start_param', isNumeric: true, isInteger: true, uiFilterTypes: ['selectedValuesFilter'] },
      { name: 'alpha_param', label: 'Alpha parameter', field: 'alpha_param', isNumeric: true, uiFilterTypes: ['selectedValuesFilter'] },
      // { name: 'used_params', label: 'Applied parameters', field: 'used_params', isCode: true },
      { name: 'fetch_input_data_time', label: 'Time to get input data, sec', field: 'fetch_input_data_time', isNumeric: true, isInteger: true },
      { name: 'training_time', label: 'Training time, sec', field: 'training_time', isNumeric: true, isInteger: true },
      { name: 'explained_variance_score', label: 'Explained variance score', field: 'explained_variance_score', isNumeric: true },
      { name: 'created_at', label: 'Created at', field: 'created_at', isDateTime: true, uiFilterTypes: ['dateFilters'] }
    ]
  },

  remoteEntityName: () => remoteEntityName,

  ...makeTableCommonGetters({ remoteEntityName })
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
